module.exports = __webpack_public_path__ + "static/section-three-99e804799df1168811eb80d36e0fb41d.png";